<template>
  <section class="pmp-card">
    <div class="pmp-section-head">
      <h1 class="pmp-section-title">Consumo de Molida</h1>
    </div>

    <div class="pmp-grid-2">
      <PMPField
        :model-value="localForm.molidaCantidad"
        id="pmp-molida-cantidad"
        label="Cantidad"
        type="text"
        inputmode="decimal"
        min="0"
        step="0.01"
        max-digits="4"
        placeholder="0"
        :error="errors.molidaCantidad"
        error-message="Ingresa una cantidad válida."
        @update:modelValue="handleMolidaCantidadInput"
      />

      <PMPDropdown
        v-model="localForm.molidaUnidad"
        label="Unidad"
        placeholder="Unidad"
        :options="unidades"
        :error="errors.molidaUnidad"
        error-message="Selecciona unidad."
        @select="handleMolidaUnidadSelect"
      />
    </div>

    <p class="pmp-helper-text">Si no aplica, ingresa 0.</p>

    <PMPField
      v-model="localForm.comentarios"
      id="pmp-comentarios"
      label="Observaciones (Opcional)"
      type="textarea"
      maxlength="280"
      :show-counter="true"
      :error="errors.comentarios"
      error-message="Revisa el comentario capturado."
      @update:modelValue="notifyFieldChange('comentarios')"
    />
  </section>
</template>

<script setup>
import { computed } from "vue";

import PMPField from "../components/PMPField.vue";
import PMPDropdown from "../components/PMPDropdown.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  unidades: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:modelValue", "field-change"]);

const localForm = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

function handleMolidaUnidadSelect(option) {
  localForm.value.molidaUnidadLabel = option.label;
  notifyFieldChange("molidaUnidad");
}

function handleMolidaCantidadInput(value) {
  localForm.value.molidaCantidad = value; // ← PMPField ya filtra
  notifyFieldChange("molidaCantidad");
}

function notifyFieldChange(field) {
  emit("field-change", { field });
}
</script>
